import {Button} from "react-bootstrap";
import styled from "styled-components";
import {green} from "../../styles/constants";
import PropTypes from "prop-types";
import Cookies from 'js-cookie';
import {useEffect, useRef, useState} from "react";

const TRACKING_ACCEPT_COOKIE_NAME = 'tracking_accept_status';

const Wrapper = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  margin-left: 2rem;
  z-index: 999;
  background: white;
  border: 1.5px solid ${green};
  max-width: 500px;
`;

const useCookieBanner = (onAccept, onReject) => {
  const isInitialized = useRef(false);
  const [showBanner, setShowBanner] = useState(false);

  // Check if cookie already exists and if so accept/decline. If not, show banner.
  useEffect(() => {
    if (isInitialized.current) return;

    const acceptStatusCookie = Cookies.get(TRACKING_ACCEPT_COOKIE_NAME);

    if (acceptStatusCookie === 'false') {
      onReject && onReject();
    } else if (acceptStatusCookie === 'true') {
      onAccept();
    } else {
      setShowBanner(true);
    }

    isInitialized.current = true;
  }, [onAccept, onReject]);

  const handleAccept = () => {
    Cookies.set(TRACKING_ACCEPT_COOKIE_NAME, 'true');
    onAccept();
    setShowBanner(false);
  };

  const handleReject = () => {
    Cookies.set(TRACKING_ACCEPT_COOKIE_NAME, 'false');
    onReject && onReject();
    setShowBanner(false);
  };

  return {
    showBanner,
    handleAccept,
    handleReject,
  };
};

const CookieBanner = (props) => {
  const { showBanner, handleAccept, handleReject } = useCookieBanner(props.onAccept, props.onReject);

  if (!showBanner) return null;

  return (
    <Wrapper className={"p-3 shadow-lg"}>
      <span className={"font-weight-bold mb-1 d-block"}>Deze website maakt gebruik van cookies</span>
      <p>
        Deze website gebruikt essentiële cookies om de goede werking ervan te garanderen en tracking cookies om te begrijpen hoe u ermee omgaat. Tracking wordt alleen ingeschakeld met uw expliciete toestemming.
      </p>

      <div className={"mt-2 d-flex"}>
        <Button onClick={handleAccept} className={"mr-2"}>Accepteren</Button>
        <Button onClick={handleReject} variant={"light"}>Weigeren</Button>
      </div>
    </Wrapper>
  )
}

CookieBanner.propTypes = {
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func,
};

CookieBanner.defaultProps = {
  onReject: null,
};

export default CookieBanner